import React from 'react';

import { SettingCompactCard } from './primitives/SettingCompactCard';

export interface SettingActionCardProps {
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  'data-tutorial'?: string;
}

/**
 * Card with content on left and custom action on right.
 *
 * Flexible action card for any button/toggle/control on the right side.
 * Used for feature toggles, custom actions, danger buttons, etc.
 */
export const SettingActionCard: React.FC<SettingActionCardProps> = ({
  children,
  action,
  className,
  'data-testid': testId,
  'data-tutorial': tutorial,
}) => {
  return (
    <SettingCompactCard
      className={className}
      data-testid={testId}
      data-tutorial={tutorial}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2">{children}</div>
      {action && (
        <div className="absolute top-1/2 right-4 -translate-y-1/2">
          {action}
        </div>
      )}
    </SettingCompactCard>
  );
};
